// The ingest pipeline stores product images as private s3:// refs; the
// image-service proxies them (same host, /_images ingress) so the browser can
// render them. Anything already http(s) passes through untouched.
const PROXIED_BUCKETS = ["youzu-download-staging"];

export function imageSrc(
  url: string | null | undefined,
  opts?: { width?: number }
): string | undefined {
  if (!url) return undefined;
  if (!url.startsWith("s3://")) return url;

  const [bucket, ...key] = url.slice("s3://".length).split("/");
  if (!PROXIED_BUCKETS.includes(bucket)) return undefined;

  const query = opts?.width ? `?w=${opts.width}` : "";
  return `/_images/b/${bucket}/${key.join("/")}${query}`;
}
